export default __webpack_public_path__ + "static/media/logo_dns.bb5fa410.png";